import type {
	Client,
	PaginatedParams,
	PaginatedQueryOptions,
} from '@lqa-frontend/api-services';
import { endpoints, usePaginatedQuery } from '@lqa-frontend/api-services';

export function useClientsQuery(
	params: ClientsQueryParams,
	options?: PaginatedQueryOptions<Client>
) {
	return usePaginatedQuery<Client>(endpoints.client.index, params, options);
}

export interface ClientsQueryParams extends PaginatedParams {
	name?: string;
	clientIds?: number[];
}
